















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { SeamlessCoreStore } from '@seamless/store';
import VueSeamlessStore from '@seamless/vue-store-plugin';
import { initializeComponentRegistry } from '@owc/component-registry-connection';
import { connectionName as aemEnvConnectionName } from '@owc/connection-aem-environment';

import {
  AUTHENTICATION_CONNECTION,
  isLoggedIn,
  getIdentityProvider,
  getClaims,
  CiasClaims,
  initializeUsingAEM,
  Alert,
  getAlert,
} from '@b2x/authentication-library';
import { AuthenticationState, IdentityProvider, Logger } from '@b2x/common';

import { AemState } from '@/common/interfaces/owc';
import UserFlyout from '@/components/user-flyout.vue';
import { B2XUMComponentConfig, UserMenuConfig } from '@/common/interfaces/common';

@Component({
  name: 'user-menu',
  mixins: [new VueSeamlessStore().mixin],
  components: {
    UserFlyout,
  },
})
export default class App extends Vue {
  store!: SeamlessCoreStore;

  componentRegistry!: any;

  config: UserMenuConfig | Record<string, string> = {};

  languageDirection = 'ltr';

  claims: CiasClaims | null = null;

  alert: Alert | null = null;

  isOpen = false;

  logger = new Logger('USER_MENU_COMPONENT');

  @Prop()
  componentId!: string;

  beforeCreate(): void {
    initializeUsingAEM();

    this.componentRegistry = initializeComponentRegistry();
  }

  async created(): Promise<void> {
    if (window.top?.aemNamespace) {
      this.logger.log('there is aemNamespace');

      this.componentRegistry.subscribe(this.componentId, this.onComponentConfig);
    } else {
      this.logger.log('there is no aemNamespace');
    }

    await this.bootstrap();
  }

  async bootstrap(): Promise<void> {
    this.logger.log('adding connections');

    this.store.subscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
    this.store.subscribe(aemEnvConnectionName, this.onAEMEvent);
  }

  mounted(): void {
    document.addEventListener('owc-header-flyout-close', this.onFlyoutClose);
  }

  onComponentConfig(componentConfig: B2XUMComponentConfig): void {
    this.logger.log('component config', componentConfig);

    this.config = componentConfig.payload;
  }

  onAEMEvent({ languageDirection }: AemState): void {
    this.logger.log(`New ${aemEnvConnectionName} event`);

    this.languageDirection = languageDirection || this.languageDirection;
  }

  onAuthenticationEvent(state: AuthenticationState): void {
    this.logger.log('New auth event', state);

    const identityProvider = getIdentityProvider(state);
    this.alert = getAlert(state);

    if (identityProvider === IdentityProvider.CIAS && isLoggedIn(state)) {
      this.claims = getClaims(state) as CiasClaims;
    } else {
      this.claims = null;
    }

    if (this.alert) {
      this.isOpen = true;
    }
  }

  onToggleMenu(): void {
    this.logger.log('toggle menu');
    this.isOpen = !this.isOpen;
  }

  onFlyoutClose(): void {
    this.isOpen = false;
  }

  beforeDestroy(): void {
    document.removeEventListener('owc-header-flyout-close', this.onFlyoutClose);

    this.store.unsubscribe(aemEnvConnectionName, this.onAEMEvent);
    this.store.unsubscribe(this.componentId, this.onComponentConfig);
    this.store.unsubscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
  }
}
